// extracted by mini-css-extract-plugin
export default {"container":"Location_container__hr2zc","break":"Location_break__JSo6v","link":"Location_link__jSdwJ"};